export const questionTypes = [
  { optionKey: "Select Question Type", optionValue: "" },
  { optionKey: "Opening Script (OS)", optionValue: "openingScript" },
  // { optionKey: "Filler (F)", optionValue: "filler" },
  { optionKey: "Filtration (FQ)", optionValue: "filtration" },
  { optionKey: "Skill Based (SB)", optionValue: "skillBased" },
  { optionKey: "Closing Script (CS)", optionValue: "closingScript" },
];

export const openingClosingScriptResponseTypes = [
  { optionKey: "Select Response Type", optionValue: "" },
  { optionKey: "No Response", optionValue: "noResponse" },
  { optionKey: "MCQ", optionValue: "mcq" },
  { optionKey: "Text", optionValue: "text" },
];

export const filtrationQuestionResponseTypes = [
  { optionKey: "Select Response Type", optionValue: "" },
  { optionKey: "MCQ", optionValue: "mcq" },
  { optionKey: "MCR", optionValue: "mcr" },
  { optionKey: "Text", optionValue: "text" },
];

export const skillBasedResponseTypes = [
  { optionKey: "Select Response Type", optionValue: "" },
  { optionKey: "Audio (AR)", optionValue: "audio" },
  { optionKey: "Code Snippet (CS)", optionValue: "codeSnippet" },
  { optionKey: "MCQ", optionValue: "mcq" },
  { optionKey: "Video (VR)", optionValue: "video" },
];
export const practiseQuestionResponseTypes = [
  { optionKey: "Select Response Type", optionValue: "" },
  { optionKey: "Audio (AR)", optionValue: "audio" },
  { optionKey: "Video (VR)", optionValue: "video" },
];

export const probingQuestionResponseType = [
  { optionKey: "Select Response Type", optionValue: "" },
  { optionKey: "Video", optionValue: "video" },
];

export const mockDomainkills = [
  { optionKey: "Select Question Competencies", optionValue: "" },
  { optionKey: "HTML", optionValue: "HTML" },
  { optionKey: "CSS", optionValue: "CSS" },
  { optionKey: "JavaScript", optionValue: "JavaScript" },
  { optionKey: "NodeJs", optionValue: "NodeJs" },
  {
    optionKey: "Data Interpratation",
    optionValue: "Data Interpratation",
  },
  {
    optionKey: "Subject Knowledge",
    optionValue: "Subject Knowledge",
  },
];

export const mockMixedSkills = [
  { optionKey: "Select Question Competencies", optionValue: "" },
  { optionKey: "HTML", optionValue: "HTML" },
  { optionKey: "CSS", optionValue: "CSS" },
  { optionKey: "JavaScript", optionValue: "JavaScript" },
  { optionKey: "NodeJs", optionValue: "NodeJs" },
  { optionKey: "Communication", optionValue: "Communation" },
  { optionKey: "Confidence", optionValue: "Confidence" },
  { optionKey: "Fluency", optionValue: "Fluency" },
  { optionKey: "Speed", optionValue: "Speed" },
];

export const chooseAQuestionType = [
  { optionKey: "Choose a Response Type", optionValue: "" },
];

export const chooseAResponseType = [
  { optionKey: "Choose a Competency", optionValue: "" },
];

export const chooseVideoType = [
  { optionKey: "Choose a Response Type", optionValue: "" },
  { optionKey: "Video", optionValue: "video" },
];
